/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentHealthSummaryAndDetails } from './providerComponentHealthSummaryAndDetails';


export interface ProviderComponentApplicationHealth { 
    general?: ProviderComponentHealthSummaryAndDetails;
    protection?: ProviderComponentHealthSummaryAndDetails;
    recovery?: ProviderComponentHealthSummaryAndDetails;
    storage?: ProviderComponentHealthSummaryAndDetails;
}

